"use client"

import type { BecomeTDFCustomerProps } from "../types"
import { RegistrationForm } from "./RegistrationForm"
import "./styles.css"
import { getFixedT } from "@/languages/i18n"

const QUICK_REGISTRATION_ICON = "/images/become-member/quick-registration.png"
const COMPLETELY_FREE_ICON = "/images/become-member/completely-free.png"

type BecomeTDFCustomerContentProps = BecomeTDFCustomerProps & {
  id: string
  submitted: boolean
  submittedEmail?: string
  onSubmitted: (email?: string) => void
  locale?: string
}

export const BecomeTDFCustomerContent = ({
  id,
  className,
  title,
  description,
  quickRegistrationText,
  freeRegistrationText,
  successTitle,
  submittedMessage,
  registrationEmail,
  registrationCode,
  noteTitle,
  notes,
  countryOptions,
  storeOptions,
  submitted,
  submittedEmail,
  onSubmitted,
  locale,
}: BecomeTDFCustomerContentProps) => {
  const t = getFixedT(locale)
  return (
    <section className={`tdf-member-root ${className || ""}`} id={id}>
      <div className="tdf-member-heading">
        {!submitted ? (
          <>
            <h2 className="tdf-member-title">{title ?? t("BECOME TDF CUSTOMER")}</h2>
            {description && <p className="tdf-member-description">{description}</p>}
            <div className="tdf-member-benefits">
              {quickRegistrationText && (
                <div className="tdf-member-benefit">
                  <img src={QUICK_REGISTRATION_ICON} alt="quick-registration" width={20} height={24} />
                  <span>{quickRegistrationText}</span>
                </div>
              )}
              {freeRegistrationText && (
                <div className="tdf-member-benefit">
                  <img src={COMPLETELY_FREE_ICON} alt="completely-free" width={31} height={24} />
                  <span>{freeRegistrationText}</span>
                </div>
              )}
            </div>
          </>
        ) : (
          <p className="tdf-member-success">{successTitle ?? t("SUCCESSFULLY SUBMITTED!")}</p>
        )}
      </div>

      <RegistrationForm
        locale={locale}
        onSubmitted={onSubmitted}
        submittedMessage={submittedMessage}
        registrationEmail={submittedEmail || registrationEmail}
        registrationCode={registrationCode}
        noteTitle={noteTitle}
        notes={notes}
        countryOptions={countryOptions}
        storeOptions={storeOptions}
      />
    </section>
  )
}
